module.exports = __webpack_public_path__ + "static/img/ddjx-2.07dd5dcc.jpg";